module.exports = { "default": require("core-js/library/fn/number/is-nan"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/number/is-nan.js
// module id = ./node_modules/babel-runtime/core-js/number/is-nan.js
// module chunks = 0 1 2